module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray-a8c88fe18fd1825fd7640f7fb05e2cd2.png";